import { render, staticRenderFns } from "./BaseResetPassword.vue?vue&type=template&id=af59c558"
import script from "./BaseResetPassword.vue?vue&type=script&lang=js"
export * from "./BaseResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports